export default "__VITE_ASSET__1aecded6__"